export default __webpack_public_path__ + "static/media/kit_svg8.a936a21d.svg";